<ng-container [formGroup]="formGroup">
  <ion-item *ngIf="configInt.type !== 'radio'
                   && configInt.type !== 'color'
                   && !onlyInput"
            lines="none"
            [disabled]="isDisabled"
            [style]="{
            '--background': backgroundColor,
            '--border-radius': borderRadius
            }">

    <ion-input type="text"
               *ngIf="configInt.type === 'text'"
               [id]="configInt.id"
               aria-describedby="basic-input"
               labelPlacement="stacked"
               [formControlName]="configInt.id"
               [maxlength]="configInt.max !== 0? configInt.max : 50"
               [label]="configInt.name | translate"
               [placeholder]="configInt.placeholder"
               required="true"
               (ionChange)="onControlChange()"
               (ionFocus)="onControlFocus()"
               (click)="onInputScroll(configInt.id)"></ion-input>

    <ion-input type="number"
               *ngIf="configInt.type === 'numberText'"
               [id]="configInt.id"
               aria-describedby="basic-input"
               labelPlacement="stacked"
               [formControlName]="configInt.id"
               [min]="configInt.min"
               [max]="configInt.max"
               [label]="configInt.name | translate"
               [placeholder]="configInt.placeholder"
               required="true"
               (ionChange)="onControlChange()"
               (ionFocus)="onControlFocus()"
               (click)="onInputScroll(configInt.id)"></ion-input>

    <ion-input type="text"
               *ngIf="configInt.type === 'date'"
               [readonly]="true"
               [id]="configInt.id"
               aria-describedby="basic-input"
               labelPlacement="stacked"
               [formControlName]="configInt.id"
               [maxlength]="configInt.max !== 0? configInt.max : 50"
               [label]="configInt.name | translate"
               required="true"
               (ionChange)="onControlChange()"
               (ionFocus)="onControlFocus()"
               (click)="onInputScroll(configInt.id)">

        <ion-popover [trigger]="configInt.id" show-backdrop="true" (willPresent)="onDateTimeShow()">
          <ng-template>
            <ion-datetime
              #popoverDate
              presentation="date"
              (ionChange)="onDateChange()">
              <span slot="title">{{ configInt.name | translate }}</span>
            </ion-datetime>
          </ng-template>
        </ion-popover>
    </ion-input>

    <ion-input type="text"
               *ngIf="configInt.type === 'time'"
               [readonly]="true"
               [id]="configInt.id"
               aria-describedby="basic-input"
               labelPlacement="stacked"
               [formControlName]="configInt.id"
               [maxlength]="configInt.max !== 0? configInt.max : 50"
               [label]="configInt.name | translate"
               required="true"
               (ionChange)="onControlChange()"
               (ionFocus)="onControlFocus()"
               (click)="onInputScroll(configInt.id)">

        <ion-popover [trigger]="configInt.id" show-backdrop="true" (willPresent)="onDateTimeShow()">
          <ng-template>
            <ion-datetime
              #popoverTime
              presentation="time"
              (ionChange)="onTimeChange()">
              <span slot="title">{{ configInt.name | translate }}</span>
            </ion-datetime>
          </ng-template>
        </ion-popover>
    </ion-input>

    <ion-textarea *ngIf="configInt.type === 'textArea'"
                  [id]="configInt.id"
                  aria-describedby="basic-input"
                  labelPlacement="stacked"
                  [formControlName]="configInt.id"
                  [maxlength]="configInt.max !== 0? configInt.max : 255"
                  counter="true"
                  [autoGrow]="true"
                  [label]="configInt.name | translate"
                  [placeholder]="configInt.placeholder"
                  required="true"
                  (ionChange)="onControlChange()"
                  (ionFocus)="onControlFocus()"
                  (click)="onInputScroll(configInt.id)"></ion-textarea>

    <ion-input *ngIf="configInt.type === 'password'"
               [type]="passType[0]"
               [id]="configInt.id"
               aria-describedby="basic-input"
               labelPlacement="stacked"
               [formControlName]="configInt.id"
               [maxlength]="configInt.max !== 0? configInt.max : 30"
               [label]="configInt.name | translate"
               [placeholder]="configInt.placeholder"
               required="true"
               (ionChange)="onControlChange()"
               (ionFocus)="onControlFocus()"
               (click)="onInputScroll(configInt.id)"></ion-input>

    <ion-buttons *ngIf="configInt.type === 'password'"
                 slot="end" class="ion-margin-top">
      <ion-button class="show-pass eye-icon" type="button"
                  (click)="togglePasswordInputType(0)">
        <i [class]="passIcon[0]"></i>
      </ion-button>
    </ion-buttons>

    <ion-select *ngIf="configInt.type === 'selectComboString' || configInt.type === 'selectComboNumber'"
                [formControlName]="configInt.id"
                [interface]="configInt.config?.mode === 'native' ? 'action-sheet' : 'popover'"
                labelPlacement="stacked"
                [placeholder]="configInt.placeholder | translate"
                [name]="configInt.id"
                (ionChange)="onControlChange()"
                (ionFocus)="onControlFocus()"
                (click)="onInputScroll(configInt.id)">
      <div slot="label">{{ configInt.name | translate }}</div>

      <ion-select-option *ngIf="configInt.optionsAll !== undefined"
                         [value]="configInt.optionsAll">
        {{ 'general.all' | translate }}
      </ion-select-option>
      <ion-select-option *ngIf="configInt.optionsNone !== undefined"
                         [value]="configInt.optionsNone">
        {{ 'general.none' | translate }}
      </ion-select-option>

      <ion-select-option *ngFor="let item of configInt.options"
                         [value]="configInt.type === 'selectComboString'? item.valueStr : item.valueNumber">
        {{ item.labelTranslate }}
      </ion-select-option>
    </ion-select>

    <ng-container [ngTemplateOutlet]="ionToggle"
                  *ngIf="(configInt.type === 'switchBoolean' || configInt.type === 'switchNumber')"></ng-container>

    <div class="range-container" *ngIf="configInt.type === 'numberSlider'">
      <ion-text>
        {{ configInt.name | translate }}: {{ formGroup.get(configInt.id)?.value ?? '--'}}
      </ion-text>
      <ion-range [formControlName]="configInt.id"
                 [min]="configInt.min"
                 [max]="configInt.max"
                 [step]="configInt.step"
                 [value]="formGroup.get(configInt.id)?.value ?? 0"
                 (ionChange)="onControlChange()"
                 (focus)="onControlFocus()"
                 (click)="onInputScroll(configInt.id)">
        <ion-icon slot="start" (click)="onSliderDecrease()" name="remove-outline"></ion-icon>
        <ion-icon slot="end" (click)="onSliderIncrease()" name="add-outline"></ion-icon>
      </ion-range>
    </div>

  </ion-item>

  <ng-container [ngTemplateOutlet]="ionToggle"
                *ngIf="(configInt.type === 'switchBoolean' || configInt.type === 'switchNumber') && onlyInput">
  </ng-container>

  <ion-radio-group *ngIf="configInt.type === 'radio'"
                   [formControlName]="configInt.id"
                   [value]="configInt.value"
                   (ionChange)="onControlChange()"
                   class="form-radio-container">
    <ion-text><h6>{{ (configInt.title) ? (configInt.title | translate) : configInt.name }}</h6></ion-text>
    <ion-radio *ngFor="let item of configInt.options"
               [name]="item.valueNumber"
               [value]="item.valueStr"
               labelPlacement="end"
               justify="start"
               (ionFocus)="onControlFocus()">{{ item.labelTranslate | translate }}</ion-radio>
  </ion-radio-group>


<!-- TEMPLATES -->
<ng-template #ionToggle>
  <div class="toggle-container">
    <ion-text *ngIf="!onlyInput">
      {{ configInt.name | translate }}

      <ion-icon *ngIf="configInt.info"
                name="info-circle"
                [id]="'trigger'+configInt.id"
                (click)="onTooltipClick($event)"></ion-icon>
    </ion-text>

    <ion-toggle [name]="configInt.id"
                [id]="configInt.id"
                [formControlName]="configInt.id"
                mode="md"
                aria-label="on-off"
                alignment="right"
                (ionChange)="onControlChange()"
                (ionFocus)="onControlFocus()">
    </ion-toggle>

    <ion-popover *ngIf="configInt.info" [trigger]="'trigger'+configInt.id" triggerAction="click">
      <ng-template>
        <ion-content class="ion-padding">
          <ion-note>
          {{ configInt.info | translate }}
        </ion-note></ion-content>
      </ng-template>
    </ion-popover>
  </div>
</ng-template>

</ng-container>

<ng-container *ngIf="configInt.type === 'color'">
  <ion-item lines="none"
            [style.--background]="backgroundColor"
            class="color-picker">
    <ion-select [(ngModel)]="colorText"
                [interface]="configInt.config?.mode === 'native' ? 'action-sheet' : 'popover'"
                labelPlacement="stacked"
                [placeholder]="configInt.placeholder | translate"
                [name]="configInt.id"
                [ngClass]="{'contrast': backgroundColor === 'var(--ion-color-dark-contrast)'}"
                (ionChange)="onColorChange()"
                (ionFocus)="onControlFocus()">
      <div slot="label">{{ configInt.name | translate }}</div>
      <ion-select-option *ngFor="let item of configInt.options"
                         [value]="item.valueStr">
        {{ item.labelTranslate }}
      </ion-select-option>
    </ion-select>

    <input type="color"
           [id]="configInt.id"
           [(ngModel)]="colorCustom"
           (change)="onColorChangeCustom()">
  </ion-item>
</ng-container>
